import type { IOrderPaymentConfirmation, IPaymentMethod } from "@/data/model/Customer";
import { PaymentFor, ServiceType } from "@/data/model/Enums";
import type { IService } from "@/data/model/Service";
import type {IOrderUseCase} from "@/data/model/OrderUseCase";
import type {IPayUseCase} from "@/data/model/PayUseCase";
import {Helper} from "@/app/ui/Helper";

export function isTipAllowedForService(service: IService | null | undefined): boolean {
    if (service == undefined) return true;

    if ([ServiceType.Order, ServiceType.Offer].includes(service.serviceType)) {
        return service?.useCase?.useTip == true;
    }

    if (service.serviceType == ServiceType.Pay) {
        return service?.payUseCase?.useTip == true;
    }

    return false;
}

export function getIsTipAllowed(
    service: IService | null | undefined,
    selectedPaymentMethod: IPaymentMethod | null
): boolean {
    if (!isTipAllowedForService(service) || selectedPaymentMethod?.isTipAllowed === false) {
        return false;
    }

    return true;
}

export function getIsApplyVouchersAllowedForOrderUseCase(
    paymentMethod: IPaymentMethod | undefined | null,
    useCase: IOrderUseCase | undefined | null,
): boolean {
    return (useCase?.useVouchersAndDiscounts ?? false) && (paymentMethod?.revenueEffective ?? true);
}

export function getIsApplyVouchersAllowedForPayUseCase(
    paymentMethod: IPaymentMethod | undefined | null,
    useCase: IPayUseCase | undefined | null,
): boolean {
    return (useCase?.useVouchersAndDiscounts ?? false) && (paymentMethod?.revenueEffective ?? true);
}

export function shouldShowReceiptActionsForOperator(options: {
    confirmation: IOrderPaymentConfirmation;
    isWaiter: boolean;
    orderServices: IService[];
    paymentServices: IService[];
}) {
    if (!options.isWaiter || options.confirmation.isPayLater) {
        return false;
    }

    if (options.confirmation.paymentFor == PaymentFor.Order) {
        const serviceWithUseCase = options.orderServices.find(
            (x) => x.useCase?.id == options.confirmation.orderUseCaseId
        );
        if (serviceWithUseCase?.useCase?.promptOperatorsForReceiptAfterPayment) {
            return true;
        }
    }

    if (options.confirmation.paymentFor == PaymentFor.Bill) {
        const serviceWithUseCase = options.paymentServices.find(
            (x) => x.payUseCase?.id == options.confirmation.payUseCaseId
        );
        if (serviceWithUseCase?.payUseCase?.promptOperatorsForReceiptAfterPayment) {
            return true;
        }
    }

    return false;
}
